var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-row",
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _vm.tab == 0
                ? _c(
                    "w-col",
                    [
                      _c("app-heading-settings", {
                        attrs: {
                          lang: _vm.selectedLanguage,
                          heading: _vm.heading,
                          fields: _vm.fields,
                        },
                        on: {
                          "update:lang": function ($event) {
                            _vm.selectedLanguage = $event
                          },
                          "convert-to-free-block": function ($event) {
                            return _vm.convertToFreeBlock()
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm.tab == 1
                ? _c(
                    "w-col",
                    [
                      _c("app-client-heading-settings", {
                        attrs: {
                          heading: _vm.clientHeading,
                          lang: _vm.selectedLanguage,
                        },
                        on: {
                          "update:lang": function ($event) {
                            _vm.selectedLanguage = $event
                          },
                          "convert-to-free-block": function ($event) {
                            return _vm.convertClientToFreeBlock(
                              _vm.clientHeading
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }